<template>
  <div class="container">
    <div class="row">
      <div class="small-12 columns text-center">
        <router-link to="/"><img src="../../assets/logo-med.png" class="logo" alt="" /></router-link>
      </div>
    </div>
    <div class="row">
      <div class="small-3 columns small-centered">
        <button class="button primary trans-uppercase" :disabled="!serviceFbReady" v-on:click="loginWithFacebook">Bejelentkezés adminként</button>
      </div>
    </div>
    <div v-if="loginWithEmailAndPasswordEnabled">
      <div class="row">
        <div class="small-3 small-centered columns mt-1 text-center">
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="small-12 small-centered columns mt-1 mb-1 text-center">
          <span>vagy bejelentkezés felhasználónévvel / jelszóval</span>
        </div>
      </div>

      <joi-form :data="data" :schema="validationSchema" v-on:formdataready="loginWithEmailAndPassword">
        <div class="row">
          <div class="form-group small-4 small-centered columns">
            <input type="email" placeholder="email" v-model="data.email" name="email" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="form-group small-4 small-centered columns">
            <input type="password" placeholder="jelszó" v-model="data.password" name="password" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="form-group small-4 small-centered columns text-center">
            <button type="submit" class="button primary trans-uppercase">Bejelentkezés</button>
          </div>
        </div>
      </joi-form>
    </div>
    <div class="row">
      <div class="small-4 columns small-centered">
        <error-callout :error="error"></error-callout>
      </div>
    </div>
  </div>
</template>

<script>
/* global SETTINGS */
import { mapState, mapMutations } from 'vuex'
import * as mutationTypes from '../store/mutation-types'
import authService from '../services/auth'
import ErrorCallout from '../errors/Callout'
import JoiForm from '../inputs/joi-form'
import validationSchemas from '../../schemas'

export default {
  name: 'welcome',
  components: {
    ErrorCallout,
    JoiForm
  },
  data () {
    return {
      error: null,
      loginWithEmailAndPasswordEnabled: SETTINGS.loginWithEmailAndPasswordEnabled,
      validationSchema: validationSchemas['auth.login'],
      data: {
        email: null,
        password: null
      }
    }
  },
  computed: {
    ...mapState(['serviceFbReady'])
  },
  methods: {
    ...mapMutations([mutationTypes.SET_USER, mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    loginWithFacebook: function () {
      this[mutationTypes.BUSY_ON]()
      authService.loginWithFacebook().then((user) => {
        this[mutationTypes.BUSY_OFF]()
        this.handleUser(user)
      })
      .catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.error = err
      })
    },
    loginGuestWithFacebook: function () {
      this[mutationTypes.BUSY_ON]()
      authService.loginGuestWithFacebook().then((user) => {
        this[mutationTypes.BUSY_OFF]()
        this.handleUser(user)
      })
      .catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.error = err
      })
    },
    async loginWithEmailAndPassword (formData) {
      this[mutationTypes.BUSY_ON]()
      try {
        let user = await authService.loginWithEmailAndPassword(formData)
        this.handleUser(user)
      } catch (error) {
        this.error = new Error('Érvénytelen felhasználónév / jelszó')
      } finally {
        this[mutationTypes.BUSY_OFF]()
      }
    },
    handleUser (user) {
      if (user.accessGranted) {
        this[mutationTypes.SET_USER](user)
        this.$router.replace('/')
      } else {
        this.$router.replace('/preregistered')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';
  @import '../../sass/layouts/form';

  .container {
    margin: 0 0 $global-margin*3 0;
  }

  img.logo {
    margin: rem-calc(40) 0 0 0;
  }

  img.phones {
    margin: rem-calc(20) 0;
  }

  .button {
    width: 100%;
    margin: $global-margin/3 0 $global-margin/3 0;
  }

  p {
    margin: 0 0 $global-margin*3 0;
  }

  .callout.error {
    margin-top: $global-margin / 3;
  }
</style>



// WEBPACK FOOTER //
// Welcome.vue?be548326